/* eslint-disable @nx/enforce-module-boundaries */
import { useDisclosure, useToast } from '@mybridge/ui/hooks';
// import { useMutation, useQuery } from '@tanstack/react-query';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import _ from 'lodash';
import qs from 'query-string';
import { createContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFullFileName } from 'v4/lib/commons';
import {
  acceptShareLink,
  copyFiles,
  copyMultipleDirs,
  copyMultipleFiles,
  createFolder,
  createShareLink,
  deleteFile,
  deleteMultipleDirs,
  deleteMultipleFiles,
  deleteShareLink,
  diskSubscriptionInit,
  getDeleteFiles,
  getOccupiedDiskSize,
  getRootDir,
  getShareLink,
  getSharedDiskUsers,
  getSharedDiskUsersByFile,
  getSharedItemUsers,
  getTeamDiskDetails,
  getUserSubscriptionDetails,
  getfileNFolder,
  initRootDirs,
  moveFiles,
  moveFolder,
  moveMultipleDirs,
  moveMultipleFiles,
  permenantMultiFilesFolderDelete,
  removeFileShare,
  removeShare,
  renameFiles,
  renameFolder,
  restoreFile,
  restoreFolder,
  restoreMultiFilesFolder,
  searchFileFolder,
  searchSharedFileFolder,
  sharedDisk,
  teamDiskCreateFolder,
} from 'v4/store/actions/myDisk.Action';
import myDiskReducer from 'v4/store/reducers/myDisk.reducer';
import { useDownloadFile } from '../hooks/useDownloadFile';
import { isDir, isFile } from '../utils';
import { getTeamMemberList } from 'v4/store/actions/teamCommunity.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const DiskContext = createContext({});

const ROOT_DIR_ORDER = ['documents', 'pictures', 'music', 'movies', 'recordings'];

export const useDiskContext = ({
  type = 'my-disk', // my-disk | team-disk
  team,
  refetchMyDiskSubscriptionEnabled = false,
  refetchMyDiskSubscriptionInitEnabled = false,
  refetchMyDiskOccupiedSizeEnabled = false,
} = {}) => {
  const [selectedMainDir, setSelectedMainDir_] = useState();
  const [selectedSharedDiskUser, setSelectedSharedDiskUser_] = useState();
  const [selectedDir, setSelectedDir_] = useState();
  const [selectedFile, setSelectedFile_] = useState();
  const [checkedFiles, setCheckedFiles_] = useState();
  const [selectedTeam, setSelectedTeam_] = useState(null);
  const [movableTeam, setMovableTeam] = useState(null);
  const [history, setHistory] = useState([]);
  const [selectedMainDirType, setSelectedMainDirType] = useState();
  const [view, setView] = useState('list'); // list | grid
  const [filters, setFilters] = useState();
  const [teamDiskMemberInfo, setTeamDiskMemberInfo] = useState(null);
  const [createSharedFolder, setCreateSharedFolder] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const { t } = useTranslator();
  const queryClient = useQueryClient();
  const createFolderDisc = useDisclosure();
  const shareDisc = useDisclosure();
  const uploadDisc = useDisclosure();
  const copyDisc = useDisclosure();
  const moveDisc = useDisclosure();
  const deleteDisc = useDisclosure();
  const renameDisc = useDisclosure();
  const downloadDisc = useDisclosure();
  const binDisc = useDisclosure();
  const multiDeleteDisc = useDisclosure();
  const multiCopyDisc = useDisclosure();
  const multiMoveDisc = useDisclosure();
  const multiRestoreDisc = useDisclosure();
  const revokeSharedDiskUserDisc = useDisclosure();
  const mobileFilePanelDisc = useDisclosure();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [downloadFileFolderLoading, setDownloadFileFolderLoading] = useState(false);
  const [selectedTypeCounts, setSelectedTypeCounts] = useState({ files: 0, directories: 0 });
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const toast = useToast({ position: 'top', isClosable: true });
  const myDisk = useSelector((state) => state.myDisk);
  const rootDirs = useMemo(() => {
    let rds = _.cloneDeep(myDisk?.rootDirs ?? []);
    return rds?.sort?.((a, b) => {
      console.warn(
        ROOT_DIR_ORDER.indexOf(a?.name),
        ' and ',
        ROOT_DIR_ORDER.indexOf(b?.name)
      );
      return ROOT_DIR_ORDER.indexOf(a?.name) - ROOT_DIR_ORDER.indexOf(b?.name);
    });
  }, [myDisk]);
  let { teamDirs } = myDisk ?? {};

  const download = useDownloadFile({ file: selectedFile });

  const downloadFileFolder = async (file) => {
    setDownloadFileFolderLoading(true);
    try {
      // Your existing download logic here
      if (typeof window === 'undefined') return;
      
      const targetFile = file || selectedFile;

      if (targetFile?.id) {
        setSelectedFile_((prev) =>
          prev && prev.id === targetFile.id
            ? {
                ...prev,
                download_count: (typeof prev.download_count === 'number' ? prev.download_count : 0) + 1,
              }
            : prev
        );

        queryClient.setQueriesData({ queryKey: ['myFiles'] }, (oldData) => {
          if (!oldData) return oldData;
          if (Array.isArray(oldData)) {
            return oldData.map((item) =>
              item?.id === targetFile.id
                ? { ...item, download_count: (item?.download_count ?? 0) + 1 }
                : item
            );
          }
          return oldData;
        });
      }

      // Call your existing download function
      // download?.onDownload();
      await download?.onDownload();
      refetchMyFiles?.();
      
      // Close the modal after download starts
      downloadDisc.onClose();
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      setDownloadFileFolderLoading(false);
    }
  };

  //custom toast messeges
  const buildActionMessage = (selectedTypeCounts, action) => {
    const { files, directories } = selectedTypeCounts;

    const getLabel = (count, singular, plural) => {
      return count === 1 ? singular : plural;
    };

    const fileLabel = getLabel(
      files,
      t('otherModules.file') || 'File',
      (t('otherModules.file') || 'File') + 's'
    );

    const folderLabel = getLabel(
      directories,
      t('myDisk.folder') || 'Folder',
      (t('myDisk.folder') || 'Folder') + 's'
    );

    if (files > 0 && directories > 0) {
      return `${files} ${fileLabel} and ${directories} ${folderLabel} ${action}`;
    } else if (files > 0) {
      return `${files} ${fileLabel} ${action}`;
    } else if (directories > 0) {
      return `${directories} ${folderLabel} ${action}`;
    } else {
      return t('toast.nothing') || `No files or folders ${action}`;
    }
  };


  // root directory listings
  const myDiskFolders = useQuery({
    queryKey: ['myDiskFolders'],
    queryFn: async () => {
      return (await dispatch(getRootDir()))?.payload ?? [];
    },
    refetchOnWindowFocus: false,
    enabled: false,
  });

  // shared directory listings
  const myDiskSharedFolders = useQuery({
    queryKey: ['myDiskSharedFolders'],
    queryFn: async () => {
      return (await dispatch(getSharedDiskUsers()))?.payload;
    },
    refetchOnWindowFocus: false,
    enabled: false,
  });

  const { data: sharedDiskUsersData } = myDiskSharedFolders ?? {};
  const { results: sharedDiskUsers } = sharedDiskUsersData ?? {};

  // bin directory listings
  const { refetch: getBinFiles, data: binFiles } = useQuery({
    queryKey: ['myDiskBin'],
    queryFn: async () => {
      return (await dispatch(getDeleteFiles({ is_deleted: true })))?.payload;
    },
    refetchOnWindowFocus: false,
    enabled: false,
  });

  useEffect(() => {
    myDiskFolders?.refetch?.();
    myDiskSharedFolders?.refetch?.();
  }, []);

  useEffect(() => {
    if (rootDirs?.length && !selectedMainDirType) {
      // setSelectedMainDir(rootDirs?.[0]);
      setSelectedMainDirType('my-disk');
    }
  }, [rootDirs, selectedMainDir]);

  useEffect(() => {
    if (myDiskFolders?.data) {
      initializeRootDirectories();
    }
  }, [myDiskFolders?.data]);

  const initializeRootDirectories = async () => {
    try {
      if (!rootDirs || rootDirs?.length <= 0) {
        await dispatch(initRootDirs());
        await dispatch(getRootDir());
      }
    } catch (e) {
      console.error(e);
    }
  };

  /**
   * Search files
   */
  const {
    data: searchFiles,
    refetch: refetchSearchFiles,
    isLoading: searchFilesLoading,
    isFetching: searchFilesFetching,
  } = useQuery({
    queryKey: ['searchFiles', filters],
    queryFn: async ({ queryKey }) => {
      const str = qs.stringify(queryKey?.[1]);
      if (selectedMainDirType === 'shared-disk') {
        return (
          (await dispatch(searchSharedFileFolder({ str })))?.payload?.results ??
          {}
        );
      } else {
        return (
          (await dispatch(searchFileFolder({ str })))?.payload?.results ?? {}
        );
      }
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  /**
   * File and folder query for selected main directory
   */
  const {
    data: myFiles,
    refetch: refetchMyFiles,
    isLoading: myFilesLoading,
    isFetching: myFilesFetching,
  } = useQuery({
    queryKey: ['myFiles', selectedDir?.id],
    queryFn: async ({ queryKey }) => {
      return (
        (
          await dispatch(
            getfileNFolder({
              parent: queryKey?.[1],
              team_id: team?.id ?? selectedMainDir?.team_info?.id,
            })
          )
        )?.payload ?? {}
      );
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  useEffect(() => {
    if (!selectedFiles || selectedFiles?.length === 0 || !Array.isArray(myFiles)) {
      setSelectedTypeCounts({ files: 0, directories: 0 });
      return;
    }
  
    const selectedIds = selectedFiles?.map(item => parseInt(item.split('_')[0], 10));
    const matchedItems = myFiles?.filter(file => selectedIds.includes(file.id));
    const counts = matchedItems?.reduce(
      (acc, item) => {
        if (item.type === 'F') acc.files += 1;
        if (item.type === 'D') acc.directories += 1;
        return acc;
      },
      { files: 0, directories: 0 }
    );
    
    setSelectedTypeCounts(counts);
  }, [selectedFiles, myFiles]);

  /**
   * File and folder query for selected team directory
   */
  const {
    data: myTeamFolders,
    refetch: refetchMyTeamFolders,
    isLoading: myTeamFoldersLoading,
    isFetching: myTeamFoldersFetching,
  } = useQuery({
    // FIX: changed key from 'myFiles' to 'myTeamFolders' to avoid cache conflict with myFiles query
    queryKey: ['myTeamFolders', movableTeam?.id],
    queryFn: async ({ queryKey }) => {
      const payload = (
        await dispatch(
          getfileNFolder({
            parent: queryKey?.[1],
            team_id: movableTeam?.team_ref,
          })
        )
      )?.payload;
      // FIX: normalize payload — handle both {results:[]} paginated and direct array responses
      if (Array.isArray(payload)) return payload;
      if (payload?.results) return payload.results;
      return [];
    },
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: !!movableTeam?.id,
  });

  /**
   * Disk Plan
   */
  const {
    data: myDiskSubscription,
    refetch: refetchMyDiskSubscription,
    isLoading: myDiskSubscriptionLoading,
    isFetching: myDiskSubscriptionFetching,
  } = useQuery({
    queryKey: ['myDiskSubscription'],
    queryFn: async ({ queryKey }) => {
      return (await dispatch(getUserSubscriptionDetails()))?.payload?.[0];
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: refetchMyDiskSubscriptionEnabled,
  });

  /**
   * Initialize default disk plan
   */
  const {
    data: myDiskSubscriptionInit,
    refetch: refetchMyDiskSubscriptionInit,
    isLoading: myDiskSubscriptionInitLoading,
    isFetching: myDiskSubscriptionInitFetching,
  } = useQuery({
    queryKey: ['myDiskSubscriptionInit'],
    queryFn: async ({ queryKey }) => {
      return (await dispatch(diskSubscriptionInit()))?.payload?.[0] ?? {};
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: refetchMyDiskSubscriptionInitEnabled,
  });

  /**
   * Disk occupied size
   */
  const {
    data: myDiskOccupiedSize,
    refetch: refetchMyDiskOccupiedSize,
    isLoading: myDiskOccupiedSizeLoading,
    isFetching: myDiskOccupiedSizeFetching,
  } = useQuery({
    queryKey: ['myDiskOccupiedSize'],
    queryFn: async ({ queryKey }) => {
      return (await dispatch(getOccupiedDiskSize()))?.payload ?? {};
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: refetchMyDiskOccupiedSizeEnabled,
  });

  /**
   * File and folder query for selected shared user
   */
  const {
    data: sharedFiles,
    refetch: refetchSharedFiles,
    isLoading: sharedFilesLoading,
    isFetching: sharedFilesFetching,
  } = useQuery({
    queryKey: ['sharedFiles', selectedSharedDiskUser?.id],
    queryFn: async ({ queryKey }) => {
      return (
        (await dispatch(getSharedItemUsers(queryKey?.[1])))?.payload?.results ??
        {}
      );
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  /**
   * Get shared users list for a file
   */
  const {
    data: fileSharedWithUsers,
    refetch: refetchFileSharedWithUsers,
    isLoading: fileSharedWithUsersLoading,
    isFetching: fileSharedWithUsersFetching,
  } = useQuery({
    queryKey: ['fileSharedWithUsers', selectedFile?.id],
    queryFn: async ({ queryKey }) => {
      return (
        (await dispatch(getSharedDiskUsersByFile({ id: queryKey?.[1] })))
          ?.payload?.results ?? {}
      );
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!selectedFile?.id,
  });

  /**
   * Get shared file's link
   */
  const {
    data: sharedFileLink,
    refetch: refetchSharedFileLink,
    isLoading: sharedFileLinkLoading,
    isFetching: sharedFileLinkFetching,
  } = useQuery({
    queryKey: ['sharedFileLink', selectedFile?.id],
    queryFn: async ({ queryKey }) => {
      try {
        const link =
          (await dispatch(getShareLink({ id: queryKey?.[1] })))?.payload ?? {};
        return link?.status_code || link?.message ? null : link;
      } catch (e) {
        console.error(e);
      }
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!selectedFile?.id,
  });

  /**
   * Get Team Disk
   */
  const {
    data: teamDisk,
    refetch: refetchTeamDisk,
    isLoading: teamDiskLoading,
    isFetching: teamDiskFetching,
  } = useQuery({
    queryKey: ['team-disk', team?.id || selectedTeam?.id],
    queryFn: async ({ queryKey }) => {
      const resp =
        (await dispatch(getTeamDiskDetails(queryKey?.[1])))?.payload ?? {};
      const teamDisk_ = _.cloneDeep(resp);
      if (teamDisk_?.id) {
        teamDisk_.team_info = team;
      }
      return teamDisk_;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: !!(team?.id || selectedTeam?.id),
  });

  /**
   * Create folder
   */
  const { mutateAsync: createFolderAsync, isLoading: createFolderLoading } =
    useMutation({
      mutationKey: ['newfolder', selectedDir?.id],
      mutationFn: async (payload) => {
        if (type === 'my-disk') {
          return (await dispatch(createFolder(payload)))?.payload ?? {};
        }
        if (type === 'team-disk') {
          return (await dispatch(teamDiskCreateFolder(payload)))?.payload ?? {};
        }
      },
    });

  /**
   * Share file with users
   */
  const {
    mutateAsync: shareFileWithUsersAsync,
    isLoading: shareFileWithUsersLoading,
  } = useMutation({
    mutationKey: ['shareFileWithUsers', selectedFile?.id],
    mutationFn: async (payload) => {
      return (await dispatch(sharedDisk(payload)))?.payload ?? {};
    },
  });
  /**
   * Unshare file with users
   */
  const {
    mutateAsync: unshareFileWithUsersAsync,
    isLoading: unushareFileWithUsersLoading,
  } = useMutation({
    mutationKey: ['unshareFileWithUsers', selectedFile?.id],
    mutationFn: async (payload) => {
      return (await dispatch(removeFileShare(payload)))?.payload ?? {};
    },
  });

  /**
   * Generate share link
   */
  const {
    mutateAsync: generateShareLinkAsync,
    isLoading: generateShareLinkLoading,
  } = useMutation({
    mutationKey: ['shareLink', selectedFile?.id],
    mutationFn: async (payload) => {
      return (await dispatch(createShareLink(payload)))?.payload ?? {};
    },
  });

  /**
   * Delete share link
   */
  const {
    mutateAsync: deleteShareLinkAsync,
    isLoading: deleteShareLinkLoading,
  } = useMutation({
    mutationKey: ['deleteShareLink', selectedFile?.id],
    mutationFn: async (payload) => {
      return (await dispatch(deleteShareLink(payload)))?.payload ?? {};
    },
  });

  /**
   * Delete
   */
  const {
    mutateAsync: deleteFileFolderAsync,
    isLoading: deleteFileFolderLoading,
  } = useMutation({
    mutationKey: ['delete', selectedFile?.id],
    mutationFn: async ({ id }) => {
      return (await dispatch(deleteFile(id)))?.payload ?? {};
    },
  });

  /**
   * Rename
   */
  const {
    mutateAsync: renameFileFolderAsync,
    isLoading: renameFileFolderLoading,
  } = useMutation({
    mutationKey: ['delete', selectedFile?.id],
    mutationFn: async ({ file, name }) => {
      const fn = isFile(file) ? renameFiles : renameFolder;
      return (await dispatch(fn({ id: file?.id, name })))?.payload ?? {};
    },
  });

  /**
   * Move
   */
  const { mutateAsync: moveFileFolderAsync, isLoading: moveFileFolderLoading } =
    useMutation({
      mutationKey: ['move', selectedFile?.id],
      mutationFn: async ({ file, parent }) => {
        const fn = isFile(file) ? moveFiles : moveFolder;
        return (await dispatch(fn({ id: file?.id, parent })))?.payload ?? {};
      },
    });

  /**
   * Copy
   */
  const { mutateAsync: copyFileFolderAsync, isLoading: copyFileFolderLoading } =
    useMutation({
      mutationKey: ['copy', selectedFile?.id],
      mutationFn: async ({ file, parent,team_id }) => {
        // const fn = isFile(file) ? copyFiles;
        return (
          (
            await dispatch(
              copyFiles({ id: file?.id, name: file?.name, parent,team_id })
            )
          )?.payload ?? {}
        );
      },
    });

  /**
   * Restore
   */
  const {
    mutateAsync: restoreFileFolderAsync,
    isLoading: restoreFileFolderLoading,
  } = useMutation({
    mutationKey: ['restore', selectedFile?.id],
    mutationFn: async ({ file, parent }) => {
      // console.log('files', _.map(file, 'id'));
      return (
        (await dispatch(
          restoreMultiFilesFolder({
            ids: _.map(file, 'id'),
            data: { is_deleted: false },
          })
        )?.payload) ?? {}
      );
    },
  });

  /**
   * Permenant Delete
   */
  const {
    mutateAsync: permenantDeleteFileFolderAsync,
    isLoading: permenantDeleteFileFolderLoading,
  } = useMutation({
    mutationKey: ['restore', selectedFile?.id],
    mutationFn: async ({ file, parent }) => {
      // console.log('files', _.map(file, 'id'));
      return (
        (await dispatch(
          permenantMultiFilesFolderDelete({
            ids: _.map(file, 'id'),
          })
        )?.payload) ?? {}
      );
    },
  });

  /**
   * Multi Delete
   */
  const {
    mutateAsync: deleteMultipleFileFolderAsync,
    isLoading: deleteMultipleFileFolderLoading,
  } = useMutation({
    mutationKey: ['delete-milti', selectedFile?.id],
    mutationFn: async ({ ids, type }) => {
      ids = ids.map((item) => item.split('_')[0]);
      const fn =
        type?.toLowerCase?.() === 'f'
          ? deleteMultipleFiles
          : deleteMultipleFiles;
      return (await dispatch(fn(ids)))?.payload ?? {};
    },
  });

  /**
   * revoke shared disk userr
   */
  const {
    mutateAsync: revokeSharedDiskUserAsync,
    isLoading: revokeSharedDiskUserLoading,
  } = useMutation({
    mutationKey: ['revoke-shared-disk-user'],
    mutationFn: async (payload) => {
      return (await dispatch(removeShare(payload)))?.payload ?? {};
    },
  });

  /**
   * Multi Copy
   */
  const {
    mutateAsync: copyMultipleFileFolderAsync,
    isLoading: copyMultipleFileFolderLoading,
  } = useMutation({
    mutationKey: ['copy-milti', selectedFile?.id],
    mutationFn: async ({ ids, parent, type, team_id }) => {
      ids = ids.map((item) => item.split('_')[0]);
      const fn =
        type?.toLowerCase?.() === 'f' ? copyMultipleFiles : copyMultipleFiles;
      return (await dispatch(fn({ parent, ids, team_id })))?.payload ?? {};
    },
  });

  /**
   * Multi Move
   */
  const {
    mutateAsync: moveMultipleFileFolderAsync,
    isLoading: moveMultipleFileFolderLoading,
  } = useMutation({
    mutationKey: ['move-milti', selectedFile?.id],
    mutationFn: async ({ ids, parent, type }) => {
      ids = ids.map((item) => item.split('_')[0]);
      const fn =
        type?.toLowerCase?.() === 'f' ? moveMultipleFiles : moveMultipleFiles;
      return (await dispatch(fn({ parent, ids })))?.payload ?? {};
    },
  });

  /**
   * Accept public link
   */
  const {
    mutateAsync: acceptPublicLinkAsync,
    isLoading: acceptPublicLinkLoading,
  } = useMutation({
    mutationKey: ['accept-public-link'],
    mutationFn: async (payload) => {
      return (await dispatch(acceptShareLink(payload)))?.payload ?? {};
    },
  });

  const setSelectedMainDir = (dir) => {
    const dir_ = { ...(dir ?? {}), isMainDir: true };
    setSelectedMainDir_(dir_);
    setSelectedDir(dir_);
  };

  const setSelectedDir = (dir) => {
    setSelectedDir_(dir);
    setSelectedFile(dir);
    setSelectedFiles([]);
  };

  const setSelectedFile = (file) => {
    setSelectedFile_(file);
  };

  const setSelectedSharedDiskUser = (user) => {
    setSelectedSharedDiskUser_(user);
  };

  // Util functions

  const createNewFolder = async (name) => {
    try {
      const created = await createFolderAsync({
        parent: selectedDir?.id,
        name,
        team_ref: team?.id ?? selectedMainDir?.team_info?.id,
      });
      if (created?.message === 'Same name directory already Existed') {
        toast({
          description: created?.message,
          status: 'error',
          duration: 9000,
          isClosable: true,
        });
      }
      createFolderDisc?.onClose?.();
      if (createSharedFolder) {
        setSelectedFile(created);
        shareDisc?.onOpen?.();
      }
      refetchFiles();
    } catch (e) {
      console.error(e);
    }
  };

  const deleteFileFolder = async (file) => {
    try {
      await deleteFileFolderAsync({ id: file?.id });
      toast({
        title: `${
          isDir(file)
            ? t('myDisk.folder') || 'Folder'
            : t('otherModules.file') || 'File'
        } ${getFullFileName(file)} ${t('myMessages.deleted') || 'deleted'}`,
        status: 'success',
      });
      deleteDisc?.onClose?.();
      multiDeleteDisc?.onClose?.();
      refetchFiles();
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  const renameFileFolder = async ({ file, name }) => {
    try {
      await renameFileFolderAsync({ file, name });
      toast({
        title: `${
          isDir(file)
            ? t('myDisk.folder') || 'Folder'
            : t('otherModules.file') || 'File'
        } ${t('toast.renamed') || 'renamed'}`,
        status: 'success',
      });
      renameDisc?.onClose?.();
      refetchFiles();
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  const moveFileFolder = async ({ file, parent }) => {
    try {
      const resp = await moveFileFolderAsync({ file, parent });
      if (resp?.message?.includes('exist')) {
        toast({
          title: `${isDir(file) ? (t('myDisk.folder') || 'Folder') : (t('otherModules.file') || 'File')} ${
            file?.name
          } ${t('toast.alreadyExists') || "already exists"}`,
          status: 'error',
        });
      } else {
        toast({
          title: `${
            isDir(file)
              ? t('myDisk.folder') || 'Folder'
              : t('otherModules.file') || 'File'
          } ${getFullFileName(file)} ${t('toast.moved') || 'moved'}`,
          status: 'success',
        });
      }
      moveDisc?.onClose?.();
      refetchFiles();
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  const copyFileFolder = async ({ file, parent, team_id }) => {
    try {
      const res = await copyFileFolderAsync({ file, parent, team_id }).then((res) => {
        toast({
          title: `${
            isDir(file)
              ? t('myDisk.folder') || 'Folder'
              : t('otherModules.file') || 'File'
          } ${getFullFileName(file)} ${t('myCalendar.copied') || 'copied'}`,
          status: 'success',
          position: 'top',
        });
      });
      copyDisc?.onClose?.();
      refetchFiles();
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  const restoreFileFolder = async ({ file, parent }) => {
    try {
      await restoreFileFolderAsync({ file, parent });
      toast({
        // title: `${isDir(file) ? 'Folder' : 'File'} ${getFullFileName(
        //   file
        // )} restored`,
        title: t('toast.filesRestored') || `Files restored`,
        status: 'success',
      });
      binDisc?.onClose?.();
      refetchFiles();
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  const permenantDeleteFileFolder = async ({ file, parent }) => {
    try {
      await permenantDeleteFileFolderAsync({ file, parent });
      toast({
        // title: `${isDir(file) ? 'Folder' : 'File'} ${getFullFileName(
        //   file
        // )} restored`,
        title: t('toast.filesDeletedPermanently') || `Files deleted permanently`,
        status: 'success',
      });
      binDisc?.onClose?.();
      refetchFiles();
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  const deleteMultipleFileFolder = async ({ ids, type }) => {
    try {
      await deleteMultipleFileFolderAsync({ ids, type });
      
      const message = buildActionMessage(selectedTypeCounts, t('pages.deleted') || "Deleted");

      toast({
        title: message || `${ids?.length} ${t('otherModules.file') || "File"}(s)/${t('myDisk.folder') || "Folder"}(s) ${t('pages.deleted') || "Deleted"}`,
        status: 'success',
      });
      multiDeleteDisc?.onClose?.();
      refetchFiles();
      setSelectedFiles([]);
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };
  // const copyMultipleFileFolder = async ({ parent, ids }) => {
  //   // Using the forEach() method

  //   try {
  //     await copyMultipleFileFolderAsync({ parent, ids });
  //     toast({
  //       title: `${ids?.length} ${t('otherModules.file') || 'File'}(s)/${
  //         t('myDisk.folder') || 'Folder'
  //       }(s) ${t('myCalendar.copied') || 'copied'}`,
  //       status: 'success',
  //     });
  //   } catch (e) {
  //     toast({ title: e?.message, status: 'error' });
  //   }
  // };

  const copyMultipleFileFolder = async ({ parent, ids, team_id }) => {
    try {
      const res = await copyMultipleFileFolderAsync({ parent, ids, team_id });
      
      const message = buildActionMessage(selectedTypeCounts, t('myCalendar.copied') || 'copied');

      toast({
        title: message || res?.response.message,
        status: 'success',
      });

      multiCopyDisc?.onClose?.();
      refetchFiles();
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  const moveMultipleFileFolder = async ({ parent, ids }) => {
    try {
      await moveMultipleFileFolderAsync({ parent, ids });

      const message = buildActionMessage(selectedTypeCounts, t('toast.moved') || 'moved');
      
      toast({
        title: message,
        status: 'success',
      });
      // toast({
      //   title: `${ids?.length} ${t('otherModules.file') || 'File'}(s)/${
      //     t('myDisk.folder') || 'Folder'
      //   }(s) ${t('toast.moved') || 'moved'}`,
      //   status: 'success',
      // });
      multiMoveDisc?.onClose?.();
      refetchFiles();
      setSelectedFiles([]);
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  const refetchFiles = () => {
    if (filters?.name?.length) {
      refetchSearchFiles();
    } else if (selectedDir?.id) {
      refetchMyFiles();
    } else if (selectedMainDirType === 'shared-disk') {
      refetchSharedFiles();
    }
    myDiskFolders?.refetch?.();
    getBinFiles?.();
    refetchMyDiskOccupiedSize?.();
  };

  const generateShareLink = async ({ accessType = 1, id,public_share_deep_link }) => {
    try {
      await generateShareLinkAsync({ id, access_type: accessType,public_share_deep_link });
      await refetchSharedFileLink();
    } catch (e) {
      console.log(e);
    }
  };

  const acceptPublicLink = async ({ id }) => {
    try {
      const resp = await acceptPublicLinkAsync({ id });
      await refetchSharedFileLink();
      return resp;
    } catch (e) {
      console.log(e);
    }
  };

  const deleteShareLink_ = async ({ id }) => {
    try {
      await deleteShareLinkAsync({ id });
      await refetchSharedFileLink();
    } catch (e) {
      console.log(e);
    }
  };

  const shareFileWithUsers = async (payload) => {
    try {
      await shareFileWithUsersAsync(payload);
      refetchFileSharedWithUsers();
      refetchFiles();
    } catch (e) {
      console.log(e);
    }
  };

  const unshareFileWithUsers = async (payload) => {
    try {
      await unshareFileWithUsersAsync(payload);
      refetchFileSharedWithUsers();
      refetchFiles();
    } catch (e) {
      console.log(e);
    }
  };

  const initDiskSubscription = async () => {
    try {
      await refetchMyDiskSubscriptionInit();
      refetchMyDiskSubscription?.();
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  const revokeSharedDiskUser_ = async (user) => {
    try {
      await revokeSharedDiskUserAsync(user?.id);
      toast({
        title:
          t('toast.sharedDiskRemoved') || `Removed shared disk successfully`,
        status: 'success',
      });
      revokeSharedDiskUserDisc?.onClose?.();
      refetchSharedFiles();
      myDiskSharedFolders?.refetch?.();
    } catch (e) {
      toast({ title: e?.message, status: 'error' });
    }
  };

  // Add this function to toggle full screen
  const toggleFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  const selectRootDir = (dir) => {
    setSelectedMainDir(dir);
    setSelectedSharedDiskUser(null);
    setSelectedMainDirType('my-disk');
    setSelectedFiles?.([]);
  };
  const selectTeamDir = async (dir) => {
    setSelectedMainDir(dir);
    await dispatch(
      getTeamMemberList({
        for_team_community_id: dir?.team_info?.id,
        list_type: 'member',
        user_id: userProfileInfo?.id,
      })
    ).then((res) => {
      if (res) {
        setTeamDiskMemberInfo(res?.payload?.disk_status);
      }
    });
    setSelectedSharedDiskUser(null);
    setSelectedMainDirType('team-disk');
    setSelectedFiles?.([]);
  };
  const selectSharedDiskUser = (user) => {
    setSelectedMainDir({});
    setSelectedSharedDiskUser(user);
    setSelectedMainDirType('shared-disk');
    setSelectedFiles?.([]);
  };

  const selectDiskType = (type) => {
    setSelectedMainDirType(type);
    setSelectedMainDir(null);
    setSelectedSharedDiskUser(null);
    setHistory([]);
    setSelectedFiles?.([]);
  };

  const checkFile = (file) => {
    const checkedFiles_ = [...(checkedFiles ?? [])];
    if (!checkedFiles_?.includes(file?.id)) {
      checkedFiles_.push(file?.id);
      setCheckedFiles_(checkedFiles_);
    }
  };

  const uncheckFile = (file) => {
    const checkedFiles_ = checkedFiles?.filter?.((f) => f !== file?.id);
    setCheckedFiles_(checkedFiles_);
  };

  const files =
    filters?.name?.length > 0
      ? searchFiles
      : selectedMainDirType === 'my-disk'
      ? selectedMainDir?.id
        ? myFiles
        : rootDirs
      : selectedMainDirType === 'shared-disk'
      ? selectedSharedDiskUser?.id
        ? selectedDir?.id
          ? myFiles
          : sharedFiles
        : sharedDiskUsers
      : selectedMainDirType === 'team-disk'
      ? selectedMainDir?.id
        ? myFiles
        : teamDirs
      : myFiles;
  // const files =
  //   filters?.name?.length > 0
  //     ? searchFiles
  //     : selectedDir?.id
  //     ? myFiles
  //     : sharedFiles;

  // const teamDisk = teamDirs?.filter?.((dir) => dir?.team_ref == team?.id)?.[0];

  return {
    ...(myDisk ?? {}),
    rootDirs,
    checkedFiles,
    teamDirs,
    checkFile,
    uncheckFile,
    createSharedFolder,
    setCreateSharedFolder,
    history,
    setHistory,
    selectedMainDir,
    setSelectedMainDir,
    setSelectedMainDirType,
    selectedMainDirType,
    refetchFiles,
    files,
    filesLoading:
      myFilesLoading ||
      myFilesFetching ||
      sharedFilesFetching ||
      sharedFilesLoading ||
      searchFilesFetching ||
      searchFilesLoading,
    selectedDir,
    setSelectedDir,
    selectedFile,
    setSelectedFile,
    selectedFiles,
    setSelectedFiles,
    createFolderDisc,
    revokeSharedDiskUserDisc,
    uploadDisc,
    sharedDiskUsersData,
    sharedDiskUsers,
    shareDisc,
    copyDisc,
    moveDisc,
    deleteDisc,
    renameDisc,
    binDisc,
    downloadDisc,
    downloadFileFolder,
    downloadFileFolderLoading,
    createNewFolder,
    createFolderLoading,
    deleteFileFolder,
    deleteFileFolderLoading,
    setView,
    view,
    binFiles,
    getBinFiles,
    renameFileFolder,
    renameFileFolderLoading,
    moveFileFolder,
    moveFileFolderLoading,
    copyFileFolder,
    copyFileFolderLoading,
    restoreFileFolder,
    restoreFileFolderLoading,
    sharedDiskUsers,
    setSelectedSharedDiskUser,
    selectedSharedDiskUser,
    sharedFiles,
    refetchSharedFiles,
    fileSharedWithUsers,
    refetchFileSharedWithUsers,
    fileSharedWithUsersLoading,
    fileSharedWithUsersFetching,
    sharedFileLink,
    refetchSharedFileLink,
    sharedFileLinkLoading: sharedFileLinkFetching || sharedFileLinkLoading,
    generateShareLink,
    generateShareLinkLoading,
    deleteShareLink: deleteShareLink_,
    deleteShareLinkLoading,
    acceptPublicLink,
    acceptPublicLinkLoading,
    shareFileWithUsers,
    shareFileWithUsersLoading,
    filters,
    setFilters,
    download,
    type,
    myDiskSubscription,
    refetchMyDiskSubscription,
    myDiskSubscriptionLoading,
    myDiskSubscriptionFetching,
    myDiskOccupiedSize,
    refetchMyDiskOccupiedSize,
    myDiskOccupiedSizeLoading,
    myDiskOccupiedSizeFetching,
    initDiskSubscription,
    refetchMyDiskSubscriptionInit,
    myDiskSubscriptionInitLoading,
    myDiskSubscriptionInitFetching,
    multiDeleteDisc,
    multiCopyDisc,
    multiMoveDisc,
    multiRestoreDisc,
    deleteMultipleFileFolder,
    deleteMultipleFileFolderLoading,
    copyMultipleFileFolder,
    copyMultipleFileFolderLoading,
    moveMultipleFileFolder,
    moveMultipleFileFolderLoading,
    toast,

    // team disk
    team,
    teamDisk,
    refetchTeamDisk,
    teamDiskLoading,
    teamDiskFetching,

    //
    selectRootDir,
    selectTeamDir,
    selectSharedDiskUser,
    selectDiskType,

    //
    revokeSharedDiskUser: revokeSharedDiskUser_,
    revokeSharedDiskUserLoading,

    unshareFileWithUsers,
    unushareFileWithUsersLoading,
    userProfileInfo,
    mobileFilePanelDisc,

    permenantDeleteFileFolder,
    permenantDeleteFileFolderLoading,

    showPreview,
    setShowPreview,
    teamDiskMemberInfo,
    setTeamDiskMemberInfo,
    selectedTeam,
    setSelectedTeam_,
    refetchMyFiles,
    myFiles,
    selectedTypeCounts,
    movableTeam,
    setMovableTeam,
    myTeamFolders,
    refetchMyTeamFolders,
    myTeamFoldersLoading,
    rootDirsLoading: myDiskFolders?.isLoading,
    isFullScreen,
    setIsFullScreen,
    toggleFullScreen,
  };
};
